// const API_BASE = process.env.BASE_API_URL || "http://localhost:8080";
// const API_BASE = "https://dynivy-app-api-850566044852.us-central1.run.app";
const API_BASE = "https://server.dynivy.com";

export default API_BASE;
